define(function (require) {
    var $ = require("jquery");
    var ko = require("knockout");
    require("bootstrap-select");

    ko.bindingHandlers.bselectOptions = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            ko.bindingHandlers.options.init(element, valueAccessor, allBindings, viewModel, bindingContext);

            $(element).selectpicker();
            $(element).addClass("bselect");
        },
        update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            ko.bindingHandlers.options.update(element, valueAccessor, allBindings, viewModel, bindingContext);

            ko.unwrap(valueAccessor());

            $(element).selectpicker("refresh");
        }
    };

    ko.bindingHandlers.bselectForeach = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            ko.bindingHandlers.foreach.init(element, valueAccessor, allBindings, viewModel, bindingContext);

            $(element).selectpicker();
            $(element).addClass("bselect");
        },
        update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            ko.bindingHandlers.foreach.update(element, valueAccessor, allBindings, viewModel, bindingContext);

            ko.unwrap(valueAccessor());

            $(element).selectpicker("refresh");
        }
    };

    ko.bindingHandlers.bselectEnable = {
        update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            ko.bindingHandlers.enable.update(element, valueAccessor, allBindings, viewModel, bindingContext);

            ko.unwrap(valueAccessor());

            $(element).selectpicker("refresh");
        }
    };

    ko.bindingHandlers.bselectValue = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            ko.bindingHandlers.value.init(element, valueAccessor, allBindings, viewModel, bindingContext);
        },
        update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            ko.bindingHandlers.value.update(element, valueAccessor, allBindings, viewModel, bindingContext);

            var val = ko.unwrap(valueAccessor());

            var uiVal = $(element).selectpicker("val");

            if (!uiVal && !val) {
                return;
            }

            if (val) {
                $(element).selectpicker("val", val);
            } else {
                // $(element).selectpicker("deselectAll");
                $(element).val("");
                $(element).selectpicker("refresh");
            }

            $(element).selectpicker("refresh");
        }
    };

    ko.bindingHandlers.bselectLoading = {
        update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            ko.unwrap(valueAccessor());

            var loadingIcon = $("<span/>", {
                class: "glyphicon glyphicon-refresh glyphicon-spin"
            });

            var caret = $(element).closest(".bootstrap-select").find("button.dropdown-toggle span.bs-caret");

            if (valueAccessor()()) {
                caret.find("span.caret").hide();
                caret.append(loadingIcon);
            } else {
                caret.find("span.caret").show();
                caret.find("span.glyphicon.glyphicon-refresh.glyphicon-spin").remove();
            }
        }
    };
});
